export default () => {
    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach((eventName) => {
        document.body.addEventListener(eventName, (e) => e.preventDefault());
    });
};
